export default "__VITE_ASSET__DC5i2kzo__"